module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteApiKeyButton.errorMessage":"There was an issue deleting the api key."}}')
  delete Component.options._Ctor
}
